<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormCliente" role="form" method="post" autocomplete="off" onSubmit="return false">
					
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objCliente.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" readonly/>
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="Rfc">Rfc</label>
							<input type="text" v-model="objCliente.Rfc" class="form-control" id="Rfc" placeholder="Ingresar Rfc" readonly/>
							<CValidation v-if="this.errorvalidacion.Rfc" :Mensaje="'*'+errorvalidacion.Rfc[0]"/>
						</div>

					</div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="Clave">Clave</label>
							<input type="text" v-model="objCliente.Clave" class="form-control" id="Clave" placeholder="Ingresar Clave" readonly/>
							<CValidation v-if="this.errorvalidacion.Clave" :Mensaje="'*'+errorvalidacion.Clave[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="Contacto">Contacto</label>
							<input type="text" v-model="objCliente.Contacto" class="form-control" id="Contacto" placeholder="Ingresar Contacto" readonly/>
							<CValidation v-if="this.errorvalidacion.Contacto" :Mensaje="'*'+errorvalidacion.Contacto[0]"/>
						</div>

					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Email">Email</label>
							<input type="text" v-model="objCliente.Email" class="form-control" id="Email" placeholder="Ingresar Email"/>
							<CValidation v-if="this.errorvalidacion.Email" :Mensaje="'*'+errorvalidacion.Email[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Direccion">Direccion</label>
							<input type="text" v-model="objCliente.Direccion" class="form-control" id="Direccion" placeholder="Ingresar Direccion" readonly/>
							<CValidation v-if="this.errorvalidacion.Direccion" :Mensaje="'*'+errorvalidacion.Direccion[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="Telefono">Telefono</label>
							<input type="text" v-model="objCliente.Telefono" class="form-control" id="Telefono" placeholder="Ingresar Telefono" readonly/>
							<CValidation v-if="this.errorvalidacion.Telefono" :Mensaje="'*'+errorvalidacion.Telefono[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="Paqueteria">Paquetería</label>
							<select v-model="objCliente.IdPaqueteria" class="form-control-search form-select" id="Paqueteria">
								<option value="0">Seleccione una opción</option>
								<option v-for="(item, index) in ListaCombo2" :key="index" :value="parseInt(item.IdPaqueteria)">{{item.Nombre}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.Paqueteria" :Mensaje="'*'+errorvalidacion.Paqueteria[0]"/>
						</div>
					</div>



					<!--<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Calle">Calle</label>
							<input type="text" v-model="objCliente.Calle" class="form-control" id="Calle" placeholder="Ingresar Calle" />
							<CValidation v-if="this.errorvalidacion.Calle" :Mensaje="'*'+errorvalidacion.Calle[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="NumExt">NumExt</label>
							<input type="text" v-model="objCliente.NumExt" class="form-control" id="NumExt" placeholder="Ingresar NumExt" />
							<CValidation v-if="this.errorvalidacion.NumExt" :Mensaje="'*'+errorvalidacion.NumExt[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="NumInt">NumInt</label>
							<input type="text" v-model="objCliente.NumInt" class="form-control" id="NumInt" placeholder="Ingresar NumInt" />
							<CValidation v-if="this.errorvalidacion.NumInt" :Mensaje="'*'+errorvalidacion.NumInt[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Cruzamiento1">Cruzamiento1</label>
							<input type="text" v-model="objCliente.Cruzamiento1" class="form-control" id="Cruzamiento1" placeholder="Ingresar Cruzamiento1" />
							<CValidation v-if="this.errorvalidacion.Cruzamiento1" :Mensaje="'*'+errorvalidacion.Cruzamiento1[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Cruzamiento2">Cruzamiento2</label>
							<input type="text" v-model="objCliente.Cruzamiento2" class="form-control" id="Cruzamiento2" placeholder="Ingresar Cruzamiento2" />
							<CValidation v-if="this.errorvalidacion.Cruzamiento2" :Mensaje="'*'+errorvalidacion.Cruzamiento2[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Colonia">Colonia</label>
							<input type="text" v-model="objCliente.Colonia" class="form-control" id="Colonia" placeholder="Ingresar Colonia" />
							<CValidation v-if="this.errorvalidacion.Colonia" :Mensaje="'*'+errorvalidacion.Colonia[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="CodigoPostal">CodigoPostal</label>
							<input type="text" v-model="objCliente.CodigoPostal" class="form-control" id="CodigoPostal" placeholder="Ingresar CodigoPostal" />
							<CValidation v-if="this.errorvalidacion.CodigoPostal" :Mensaje="'*'+errorvalidacion.CodigoPostal[0]"/>
						</div>
					</div>
						
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Municipio">Municipio</label>
							<select v-model="objCliente.Municipio" class="form-control-search form-select" id="Municipio">
								<option value="0">Seleccione una opción</option>
								<option v-for="(item, index) in ListaCombo1" :key="index" :value="item.Municipio">{{item.Nombre}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.Municipio" :Mensaje="'*'+errorvalidacion.Municipio[0]"/>
						</div>
					</div>
						
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Estado">Estado</label>
							<select v-model="objCliente.Estado" class="form-control-search form-select" id="Estado">
								<option value="0">Seleccione una opción</option>
								<option v-for="(item, index) in ListaCombo2" :key="index" :value="item.Estado">{{item.Nombre}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.Estado" :Mensaje="'*'+errorvalidacion.Estado[0]"/>
						</div>
					</div> -->

					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormCliente',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCliente: {
				IdCliente: 0,
				IdClienteMicrosip: 0,
				IdPaqueteria: 0,
				Clave: '',
				Nombre: '',
				Contacto: '',
				Direccion: '',
				Calle: '',
				NumExt: '',
				NumInt: '',
				Cruzamiento1: '',
				Cruzamiento2: '',
				Colonia: '',
				CodigoPostal: '',
				Municipio: '',
				Estado: '',
				Telefono: '',
				Email: '',
				Rfc: '',
				Estatus: '',
				
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
			ListaCombo1: [],
			ListaCombo2: [{
				IdPaqueteria: 1,
				Nombre: 'DHL'
			}],
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objCliente.IdCliente == 0) {
				await this.$http.post(
					'clientes',this.objCliente
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'clientes/'+this.objCliente.IdCliente,
					this.objCliente
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "clientes/"+this.objCliente.IdCliente
            ).then((res) => {
                this.objCliente = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objCliente.Fecha.replace(/-/g,'\/');
                this.objCliente.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objCliente = {
				IdCliente: 0,
				IdClienteMicrosip: 0,
				IdPaqueteria: 0,
				Clave: '',
				Nombre: '',
				Contacto: '',
				Direccion: '',
				Calle: '',
				NumExt: '',
				NumInt: '',
				Cruzamiento1: '',
				Cruzamiento2: '',
				Colonia: '',
				CodigoPostal: '',
				Municipio: '',
				Estado: '',
				Telefono: '',
				Email: '',
				Rfc: '',
				Estatus: '',
				
            }
            this.errorvalidacion = [];
        },
		GetListCombo1()
		{
			this.$http.get("nombreDeLaApi", {
				params:{
					//simple: 1,
				}
			}).then((res) => {
				this.ListaCombo1 = res.data.row;
			});
		},
		GetListCombo2()
		{
			this.$http.get("nombreDeLaApi", {
				params:{
					//simple: 1,
				}
			}).then((res) => {
				this.ListaCombo2 = res.data.row;
			});
		},
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objCliente.IdCliente = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
